import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import Results from "@/pages/Results";
import EscapadeDetail from "@/pages/EscapadeDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Premium from "@/pages/Premium";
import LegalPage from "@/pages/LegalPage";
import RecoverAccess from "@/pages/RecoverAccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/resultats/:searchId" element={<Results />} />
            <Route path="/escapade/:id" element={<EscapadeDetail />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/premium/:token" element={<Premium />} />
            <Route path="/acces" element={<RecoverAccess />} />
            <Route path="/mentions-legales" element={<LegalPage page="mentions" />} />
            <Route path="/cgv" element={<LegalPage page="cgv" />} />
            <Route path="/confidentialite" element={<LegalPage page="confidentialite" />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
